interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-stone-900/97 backdrop-blur-md shadow-lg shadow-amber-900/30'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <div
            className="flex flex-col cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <span className="text-amber-100 font-black text-xs md:text-sm uppercase tracking-[0.15em] md:tracking-[0.2em] leading-tight">
              The Forgotten Felon
            </span>
            <span className="text-amber-400 font-bold text-[10px] md:text-xs uppercase tracking-[0.2em] md:tracking-[0.3em]">
              Blueprint
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-10">
            {['about', 'reviews', 'purchase'].map((section) => (
              <button
                key={section}
                onClick={() => scrollToSection(section)}
                className="text-sm font-medium tracking-widest uppercase text-amber-100/70 hover:text-amber-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollToSection('purchase')}
            className="px-3 py-2 md:px-6 md:py-2.5 bg-amber-600 text-amber-50 text-[10px] md:text-xs font-bold uppercase tracking-wider md:tracking-widest hover:bg-amber-500 transition-all duration-300 shadow-md hover:shadow-amber-700/40 whitespace-nowrap cursor-pointer"
          >
            Get the Book
          </button>
        </div>
      </div>
    </nav>
  );
}
